import DocumentTypeSelector from './DocumentTypeSelector';

export default DocumentTypeSelector;
